import lodashGet from 'lodash/get';

export const ClientArchiveHelper = {
  /**
 * Essaye d'extraire le client de l'archive, renvoi null si le client n'existe pas
 * @param {number} id id du client
 * @param {() => any} getState fonction pour obtenir le state
 */
  GetClientById(id, getState) {
    const currentStoreState = getState();

    const client = lodashGet(currentStoreState, `contextAppData.clientsDico.${id}`, null);

    return client;
  }
}
